import BaseAPI from './base'
/**
 * API xử lý đăng ký học liệu Học Mãi
 */
class CartRegistrationFromAPI extends BaseAPI {}

export default new CartRegistrationFromAPI('v1/cart-registration-form', 'CartRegistrationForm')
